/**
 * Single source of truth for the low-confidence warning threshold.
 *
 * An extracted AI value whose grounding confidence is below this gets an
 * amber "low confidence" warning. Previously each surface hard-coded its own
 * cutoff (Q&A used 0.8, reports and field-fill used 0.7), so the same answer
 * could look fine in one screen and flagged in another. Standardizing at the
 * higher value means borderline values are surfaced everywhere, not hidden in
 * client-facing reports.
 */
export const LOW_CONFIDENCE_THRESHOLD = 0.8;
